module.exports = __webpack_public_path__ + "static/media/photo-02-cgv.75b0a2af.png";